<template>
  <div id="tabs">
    <ul>
      <li><a href="#tabs-pedido">Pedidos</a></li>
      <li><a href="#tabs-elogios">Elogios</a></li>
      <li><a href="#tabs-reclamacoes">(Reclamações) Conduta de Colaborador</a></li>
      <li><a href="#tabs-atraso-atendimento">(Reclamações) Atraso de Atendimento</a></li>
      <li><a href="#tabs-ocorrencias-transito">Ocorrências de trânsito</a></li>
    </ul>

    <div class="row">
      <div class="col-md-12" id="tabs-pedido">
        <dt-pedidos/>
      </div>

      <div class="col-md-12" id="tabs-elogios">
        <dt-elogios/>
      </div>

      <div class="col-md-12" id="tabs-reclamacoes">
        <dt-reclamacoes/>
      </div>

      <div class="col-md-12" id="tabs-atraso-atendimento">
        <dt-atraso-atendimento/>
      </div>

      <div class="col-md-12" id="tabs-ocorrencias-transito">
        <dt-ocorrencias-transito/>
      </div>
    </div>

  </div>

</template>
<script>
import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

export default {
    data(){},
    mounted(){}
}
</script>

<style scoped>
    .custom-input-group {
        display: flex;
        height: 5em;
        justify-content: center;
        align-items: center;
    }
    .filter-select-group {
        display: flex;
        flex-direction: row;
        padding: 10px;
    }
    .filter-select-group input {
        height: 1.5em;
        width: 2em;
        margin: 0px;
        padding: 10px;
    }
    .filter-select-group input:focus {
        box-shadow: none;
    }
    .filter-select-group label {
        margin: 0px;
        font-size: 12px;
        align-self: center;
    }
    .filter-group {
        display: flex;
        flex-direction: column;
        margin: 0px;
    }
    .filter-group input {
        width: 70%;
        margin: 5px;
    }
    .filter-group input[type='date'] {
        width: 100%;
        margin: 0;
    }
    .filter-group button {
        margin: 5px;
        height: 2.5em;
        border-radius: 5px !important;
    }
    .filter-select-label {
        font-weight: bold;
        font-size: 18px;
        align-self: center
    }
    #filter-select-container {
        border-right: 2px solid lightgray;
    }
    #history-container {
        margin: 10px;
    }
    #view-button {
        background: none;
        border: none;
        padding: 0;
        box-shadow: none;
        outline: none;
    }
    #view-button i {
        color: #1c869a;
        font-size: 22px;
    }
    #view-button i:hover {
        color: #31bdda;
        transition: 0.5s;
    }

</style>